import './PayForm.sass';

import React, { FC, useEffect, useRef, useState } from 'react';
import { useRoute } from 'react-router5';

import { Header } from '$uikit';
import { classNames, payFormPatch, statReachGoal } from '$utils';
import { Loader } from '$shared/components';
import { usePayFormTranslations, useTranslator } from '$hooks';
import { useDispatch, useSelector } from 'react-redux';
import { balancePayActions, balancePaySelector } from '$store/balancePay';

export const PayForm: FC = () => {
  const { route } = useRoute();
  const t = useTranslator();
  const dispatch = useDispatch();
  const balancePay = useSelector(balancePaySelector);
  const translations = usePayFormTranslations();
  const [isFormReady, setFormReady] = useState(false);
  const interval = useRef<ReturnType<typeof setTimeout>>();
  const frame = useRef<any>();
  const token = route.params.token as string;

  useEffect(() => {
    if (balancePay.action) {
      dispatch(balancePayActions.saveContext());
    }
  }, [balancePay]);

  useEffect(() => {
    if (token) {
      frame.current.contentWindow.addEventListener('DOMContentLoaded', () => {
        const PaymentForm = frame?.current.contentWindow.SmglPaymentForm;
        const paymentForm = new PaymentForm(token, translations);
        paymentForm.onReady = () => {
          setFormReady(true);
          payFormPatch(frame?.current.contentWindow);
        };
        paymentForm.render();
      });
    }

    statReachGoal('pay_form');
  }, [token]);

  return (
    <>
      <Header showBackButton>{t('pay_form_title')}</Header>
      <iframe
        ref={frame}
        src={`/pay_form.html`}
        className={classNames({
          PayForm__form_wrap: true,
          hidden: !isFormReady,
        })}
        frameBorder={0}
      />
      {!isFormReady && <Loader isWrapped />}
    </>
  );
};
